/**
 * Get normalized direction vector of the view point.
 */
import { ViewPoint } from '../../models/view-point';
import { Box3, Camera, Object3D, Vector3 } from 'three';

export function getDirectionVector(viewPoint: ViewPoint): Vector3 {
  switch (viewPoint) {
    case ViewPoint.Back:
      return new Vector3(0, 1, 0);
    case ViewPoint.Bottom:
      return new Vector3(0, 0, -1);
    case ViewPoint.Front:
      return new Vector3(0, -1, 0);
    case ViewPoint.Left:
      return new Vector3(-1, 0, 0);
    case ViewPoint.Right:
      return new Vector3(1, 0, 0);
    case ViewPoint.Top:
      return new Vector3(0, 0, 1);
    case ViewPoint.TopLeft:
      return new Vector3(-1, -1, 1);
    case ViewPoint.TopRight:
      return new Vector3(1, -1, 1);
    case ViewPoint.BottomLeft:
      return new Vector3(-1, -1, -1);
    case ViewPoint.BottomRight:
      return new Vector3(1, -1, -1);
  }
  throw new Error(`Argument out of range: ${viewPoint}`);
}

/**
 * Adjust camera to look at the target from a view point.
 * Camera's current distance from the target is preserved.
 */
export function lookFrom(camera: Camera, target: Object3D, viewPoint: ViewPoint): void {
  const bb = new Box3().setFromObject(target);
  const lookAtPosition = new Vector3();
  bb.getCenter(lookAtPosition);
  const distance = camera.position.distanceTo(lookAtPosition);
  const direction = getDirectionVector(viewPoint).multiplyScalar(distance);
  const position = lookAtPosition.add(direction);
  camera.position.copy(position);
}
